import { render, staticRenderFns } from "./LeaderBoardHead.vue?vue&type=template&id=21958aa3&scoped=true&"
import script from "./LeaderBoardHead.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardHead.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardHead.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeaderBoardHead.vue?vue&type=style&index=1&id=21958aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21958aa3",
  null
  
)

export default component.exports